// Scroll reveals. Elements are tagged `.will-reveal` from JS (never in markup),
// so if this module doesn't run — old browser, reduced motion — nothing is
// ever hidden. `.revealed` flips once on first intersection.
export function initReveals(
  root: ParentNode,
  selector: string,
  staggerMs = 0
): () => void {
  const reduced =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    document.documentElement.dataset.reducedMotion === "true";
  if (reduced || !("IntersectionObserver" in window)) return () => {};

  const els = Array.from(root.querySelectorAll<HTMLElement>(selector));
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          io.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.1, rootMargin: "0px 0px -6% 0px" }
  );

  els.forEach((el, i) => {
    el.classList.add("will-reveal");
    if (staggerMs) el.style.transitionDelay = `${(i % 4) * staggerMs}ms`;
    io.observe(el);
  });

  return () => {
    io.disconnect();
    for (const el of els) {
      el.classList.remove("will-reveal", "revealed");
      el.style.removeProperty("transition-delay");
    }
  };
}
